module.exports = __webpack_public_path__ + "static/2018-10-22-PODCAST_Diagnosis-aa90633c260a7ea3776859ef0c344e1d.mp3";